import styled from "styled-components";

export const StyledClickAwayWrapper = styled.div``;
